import Http from "../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../core/HttpResponse";
import { Form_Create_Product } from "../../form/FormCreate";
import { Form_Update_Product } from "../../form/FormUpdate";
import { M_Product } from "../../type/Produk.type";

export interface Http_GET_Products extends HttpBaseRequest {
  max_price?: string;
  min_price?: string;
  product_category_id?: string;
  product_brand_id?: string;
  stock?: string;
  has_tax?: string;
}

export const getProducts = async ({
  has_tax,
  keyword,
  max_price,
  min_price,
  page,
  perPage,
  product_brand_id,
  product_category_id,
  stock,
}: Http_GET_Products) => {
  const results = await Http.get<HttpBaseResponse<HttpData<M_Product[]>>>({
    url: "/product",
    params: {
      has_tax,
      keyword,
      max_price,
      min_price,
      page,
      perPage,
      product_brand_id,
      product_category_id,
      stock,
    },
  });
  return results;
};

export const getProduct = async ({ product_id }: { product_id: string }) => {
  const results = await Http.get<HttpBaseResponse<M_Product>>({
    url: `/product/detail`,
    params: {
      product_id,
    },
  });
  return results;
};

export const addProduct = async ({
  buying_price,
  has_tax,
  price,
  product_brand_id,
  product_category_id,
  product_type_name,
  stock,
  unit_type,
  wholesale_price,
  skip_stock,
}: Form_Create_Product) => {
  const results = await Http.post({
    url: "/product/insert",
    useFormMultiPart: false,
    data: {
      buying_price,
      has_tax,
      price,
      product_brand_id,
      product_category_id,
      product_type_name,
      stock,
      unit_type,
      wholesale_price,
      skip_stock,
    },
  });
  return results;
};

export const updateProduct = async ({
  product_id,
  buying_price,
  has_tax,
  price,
  product_brand_id,
  product_category_id,
  product_type_name,
  stock,
  unit_type,
  wholesale_price,
}: Form_Update_Product) => {
  const results = await Http.post({
    url: "/product/update",
    data: {
      product_id,
      buying_price,
      has_tax,
      price,
      product_brand_id,
      product_category_id,
      product_type_name,
      stock,
      unit_type,
      wholesale_price,
    },
  });
  return results;
};

export const importProduct = async ({ file }: { file: File }) => {
  const results = await Http.post({
    url: "/product/import",
    data: {
      file,
    },
  });
  return results;
};
